import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import How from "./how";
import { toast } from "react-toastify";
import { create } from "../services/services";
import { useDispatch } from "react-redux";
import { addToFavorites } from "../store/slices/favorisSlice";
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import { slugify } from "../utils/utils";
const getCurrentMonthName = () => {
  const months = [
    "jan",
    "fév",
    "mar",
    "avr",
    "mai",
    "juin",
    "juil",
    "août",
    "sep",
    "oct",
    "nov",
    "déc",
  ];
  return months[new Date().getMonth()];
};

const generateNext8Days = () => {
  const daysOfWeek = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];

  const today = new Date();
  return Array.from({ length: 8 }, (_, index) => {
    const nextDate = new Date();
    nextDate.setDate(today.getDate() + index);
    return {
      short: daysOfWeek[nextDate.getDay()],
      date: nextDate.getDate(),
      month: getCurrentMonthName(),
    };
  });
};

const SearchResultCard = ({
  result,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  isAuthenticated,
}) => {
  const upcomingDays = generateNext8Days();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [localResult, setLocalResult] = useState(result);
  const formattedDisponibilites = Object.entries(result?.availability_next_8_days).map(([date, status]) => {
    const dateObj = parseISO(date);
    return {
      date: format(dateObj, 'd'),
      month: format(dateObj, 'MMM', { locale: fr }),
      short: format(dateObj, 'EEE', { locale: fr }),
      active: status === "open"
    };
  });
  const groupedSchedules = result.horaires.reduce((acc, horaire) => {
    const day = horaire.jour.toLocaleLowerCase()?.slice(0, 3);
    if (!acc[day]) acc[day] = [];
    acc[day].push(horaire);
    return acc;
  }, {});

  const lieux = localResult.lieu_intervention
    ? Array.isArray(localResult.lieu_intervention)
      ? localResult.lieu_intervention.map((lieu) => lieu.trim())
      : localResult.lieu_intervention.split(",").map((lieu) => lieu.trim())
    : [];

  return (
    <div
      className={`search-result-card ${isHovered ? "hovered" : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="card-content row">
        <div className="card-left col-md-5">
          <div className="image-container">
            <img
              src={
                localResult.photos?.[0]?.url_photo
                  ? process.env.REACT_APP_FILE_URL +
                  localResult.photos[0].url_photo
                  : "/images/default.svg"
              }
              alt={localResult.nom}
              className="result-image"
            />
          </div>
        </div>

        <div className="card-right col-md-7">
          <div className="establishment-info d-flex justify-content-between align-items-center">
            <h3 className="establishment-name">{localResult.nom}</h3>
            {localResult?.immediat ? (
              <img
                src="/images/immediat.svg"
                alt="immediat"
                className="immediat-icon"
              />
            ) : (
              ""
            )}
          </div>
          <p className="establishment-review d-flex align-items-center">
            {localResult?.activite?.name}{" "}
            <img src="/images/star.svg" alt="star" className="ml-8 mr-4" />{" "}
            {localResult?.average_rating} ({localResult?.reviews_count || 0}{" "}
            avis)
          </p>

          <p className="establishment-address legend">
            {localResult.adresse_postale}, {localResult.code_postal},{" "}
            {localResult.ville}
          </p>

          <div className="service-badges mt-8">
            <How lieu_intervention={lieux} />
          </div>

          <div className="schedule-grid">

            {formattedDisponibilites.length > 0 && (
              <>
                {formattedDisponibilites.map((day, index) => {
                  const isActive = day?.active;
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        if (isActive) {
                          navigate(`/etablissement/${localResult?.slug}`, { state: { idEtablissement: localResult?.id } })
                          //  navigate(`/etablissement/${}})
                          // navigate(`/etablissement/${localResult.id}`)
                        }

                      }}
                      className={`day-box ${isActive ? "active pointer" : "inactive"}`}
                    >
                      <div className="day-name">{day.short}</div>
                      <div className="day-date">
                        {day.date} {day.month}
                      </div>
                    </div>
                  );
                })}

              </>
            )}
          </div>

          <div className="d-flex justify-content-end align-items-center gap-3 mt-24">
            <span className="no-decoration">
              <div
                className="d-flex align-items-center pointer"
                onClick={() => {
                  // console.log("Clicked! isAuthenticated:", isAuthenticated); // Debug
                  if (isAuthenticated) {
                    setLocalResult(prev => ({
                      ...prev,
                      is_favorited: !prev.is_favorited,
                    }));
                    // console.log("Dispatching favorite for ID:", result?.id); // Debug
                    dispatch(addToFavorites(result?.id));
                  } else {
                    // console.log("Redirecting to login..."); // Debug
                    toast.warning("Veuillez vous connecter pour ajouter aux favoris");
                    navigate("/login");
                  }
                }}
              >
                {localResult?.is_favorited ? (
                  <img
                    src="/images/heart-fill.svg"
                    alt="heart"
                    className="heart-icon"
                  />
                ) : (
                  <span className="link-blue">
                    {" "}
                    <img
                      src="/images/heart.svg"
                      alt="heart"
                      className="heart-icon"
                    />{" "}
                    Enregistrer
                  </span>
                )}
              </div>
            </span>
            <button
              className="twyny-cta-primary mr-8"
              onClick={() => navigate(`/etablissement/${localResult?.slug}`, { state: { idEtablissement: localResult?.id } })
              }
            >
              Voir les services
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResultCard;
